var watchlistList = {
	caption: "Lista de seguimiento",
	name: "Nombre",
	numberOfPositions: "Posiciones",
	actions: "Acciones",
	createWatchlistAction: "Añadir Lista de Seguimiento",
	editWatchlistAction: "Editar Lista de Seguimiento",
	deleteWatchlistAction: "Eliminar Lista de Seguimiento",
	noWatchlist: {
		title: "Info",
		message: "Aún no se ha creado ninguna lista de seguimiento. Haga clic en el botón Añadir lista de seguimiento y complete el formulario para crear una lista de seguimiento."
	},
	showActions: "Mostrar acciones"
};
var es = {
	watchlistList: watchlistList
};

export { es as default, watchlistList };
